import SectionTitle from '../../components/SeccionTitle';

export default function Error() {
	return <SectionTitle title='Error 404 página no encontrada' />;
}
